import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
} from "@chakra-ui/react";

const ConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    title = "Confirmation",
    message = "Are you sure?",
    loading = false,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />

            <ModalContent>
                <ModalHeader>{title}</ModalHeader>

                <ModalBody>
                    <Text>{message}</Text>
                </ModalBody>

                <ModalFooter>
                    <Button mr={3} onClick={onClose}>
                        No
                    </Button>

                    <Button
                        colorScheme="red"
                        onClick={onConfirm}
                        isLoading={loading}
                    >
                        Yes
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmationModal;